export enum TipoModalEnum {
    ERRO,
    SUCESSO,
    ALERTA,
    PADRAO,
}